import { Text } from "@marekl/adminer/components";
import { ROLE_LABELS } from "./memberFormSchema";
import type { MembershipRole } from "../../../lib/queries/memberships";

/**
 * RoleCell renders a roster row's "Role" column. Leadership reads as the
 * first (bold) entry in the role list, which ties the row to the leader
 * card above it — leadership and season membership are two records for one
 * person, and this is what makes that visible.
 *
 * A leader with no competitive role therefore reads „Vedoucí" alone, which
 * is a valid state; any other member without roles is not, so it reads as
 * an em dash.
 *
 * The leader branch is ONE span on purpose: in `cards` mode the library makes
 * every <td> a flex row with a gap, so a bare <strong> beside a text node
 * would render as „Vedoucí , Trenér".
 */
export function RoleCell({ roles, isLeader }: { roles: MembershipRole[]; isLeader: boolean }) {
  const labels = roles.map((r) => ROLE_LABELS[r]);
  if (!isLeader) {
    return labels.length > 0 ? <>{labels.join(", ")}</> : <Text variant="muted">—</Text>;
  }
  return (
    <span>
      <strong>Vedoucí</strong>
      {labels.length > 0 && `, ${labels.join(", ")}`}
    </span>
  );
}
